import { connect } from 'react-redux';
import {
  goalId,
  goalViewState,
} from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import MobileView from '../../MobileFinancialPlan/MobileInsurance/MobileInsuranceView';
import { isCurrentPlanSelector } from '../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';
import { setReactCalibrationWidget } from '../FinancialPlanActions';
import { getGoal } from '../FinancialPlanHelpers';
import { calibration, data as dataSelector } from '../FinancialPlanSelector';
import { LIFE } from './InsuranceConstants';
import View from './InsuranceView';

const mapStateToProps = (state, ownProps) => {
  const data = dataSelector(state, ownProps);
  const goal = getGoal(data, goalId(state, ownProps));
  // Defaulting to LIFE for the first render
  const selectedSection =
    ownProps.selectedSection || goalViewState(state, ownProps).selectedSection || LIFE;

  let insuranceGoal;

  if (goal.GoalType === 'insurance') {
    insuranceGoal = goal;
  }

  return {
    selectedSection,
    calibration: calibration(state, ownProps),
    isCurrentPlan: isCurrentPlanSelector(state, ownProps),
    goalId: goal.GoalId,
    insuranceGoal,
    data,
  };
};

const mapDispatchToProps = dispatch => ({
  setReactCalibrationWidget: (calibration, clientId) => {
    dispatch(setReactCalibrationWidget(calibration, clientId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileInsurance = connect(mapStateToProps, mapDispatchToProps)(MobileView);
